import { useState } from "react";
import { motion } from "framer-motion";
import { FileDown, Loader2, Check } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Leseprobe = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/leads/sample`, { email, origin_url: window.location.origin });
      toast.success("Freigegeben. Deine Leseprobe wird geladen.");
      window.open(`${API}/sample.pdf`, "_blank");
      setEmail("");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Bitte gib eine gültige E-Mail-Adresse ein.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="leseprobe" className="relative py-20 lg:py-28" data-testid="leseprobe-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="relative glass rounded-2xl p-8 sm:p-12 lg:p-16 overflow-hidden"
        >
          <div className="absolute -top-20 -right-20 w-80 h-80 bg-white/5 blur-3xl rounded-full pointer-events-none" />
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center relative">
            <div className="lg:col-span-7">
              <span className="stamp text-xs" data-testid="leseprobe-stamp">
                Gratis · Erste Seiten
              </span>
              <h2 className="font-cinzel text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight mt-6">
                Lies die Akte,
                <br />
                bevor du sie kaufst
              </h2>
              <ul className="mt-6 space-y-2.5 text-sm sm:text-base text-slate-300">
                {[
                  "Die ersten Seiten von Band 1 als PDF",
                  "Direkt im Browser, kein Warten, kein Risiko",
                  "Du landest auf der Freigabe-Liste für Band 2 & 3",
                ].map((b) => (
                  <li key={b} className="flex gap-3 items-start">
                    <Check className="w-4 h-4 text-white mt-1 shrink-0" />
                    {b}
                  </li>
                ))}
              </ul>
            </div>
            <div className="lg:col-span-5">
              <form onSubmit={submit} className="flex flex-col gap-4">
                <label
                  htmlFor="leseprobe-email"
                  className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500"
                >
                  Deine E-Mail-Adresse
                </label>
                <input
                  id="leseprobe-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="deine@email.de"
                  required
                  data-testid="leseprobe-email-input"
                  className="w-full bg-white/5 border border-white/10 rounded-full px-6 py-4 text-base text-white placeholder:text-slate-600 focus:outline-none focus:border-white/50 transition-colors"
                />
                <button
                  type="submit"
                  disabled={loading}
                  data-testid="leseprobe-submit-button"
                  className="glow-btn w-full !py-4 min-h-[56px] text-base disabled:opacity-60 disabled:pointer-events-none"
                >
                  {loading ? (
                    <Loader2 className="w-4 h-4 animate-spin" />
                  ) : (
                    <FileDown className="w-4 h-4" />
                  )}
                  Leseprobe freigeben
                </button>
                <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-600 text-center">
                  Kein Spam. Nur Signale.
                </p>
              </form>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
